import { api } from "./api";
import { toast } from "sonner";

const DB_NAME = "bpt_offline";
const STORE = "queue";

const openDb = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB_NAME, 1);
  req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

export const addToQueue = async (item) => {
  const db = await openDb();
  await new Promise((res, rej) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).add({ ...item, created_at: new Date().toISOString() });
    tx.oncomplete = res;
    tx.onerror = () => rej(tx.error);
  });
  window.dispatchEvent(new Event("bpt-offline-queue"));
};

export const getQueue = async () => {
  const db = await openDb();
  return new Promise((res, rej) => {
    const req = db.transaction(STORE, "readonly").objectStore(STORE).getAll();
    req.onsuccess = () => res(req.result || []);
    req.onerror = () => rej(req.error);
  });
};

const removeFromQueue = async (id) => {
  const db = await openDb();
  await new Promise((res, rej) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = res;
    tx.onerror = () => rej(tx.error);
  });
};

let flushing = false;
export const flushQueue = async () => {
  if (flushing || !navigator.onLine) return { verzonden: 0 };
  flushing = true;
  let verzonden = 0;
  try {
    const items = await getQueue();
    for (const it of items) {
      try {
        await api[it.method](it.path, it.payload);
        await removeFromQueue(it.id);
        verzonden++;
      } catch (e) {
        if (!e.response) break; // nog steeds geen verbinding — later opnieuw
        await removeFromQueue(it.id);
        if (window.__bptFlags?.mobiel_offline_v1) {
          const reden = e.response?.data?.detail;
          await nietVerwerktBewaar({ ...it, reden: typeof reden === "string" ? reden : JSON.stringify(reden || e.response.status) });
          toast.error(`Offline item "${it.label || it.path}" geweigerd — bewaard onder 'Niet verwerkt' (aanpassen en opnieuw versturen)`, { duration: 8000 });
        } else {
          toast.error(`Offline item "${it.label || it.path}" geweigerd door de server en verwijderd uit de wachtrij`);
        }
      }
    }
  } finally {
    flushing = false;
  }
  if (verzonden > 0) {
    toast.success(`${verzonden} offline formulier(en) gesynchroniseerd`, { duration: 6000 });
    window.dispatchEvent(new Event("bpt-offline-queue"));
  }
  return { verzonden };
};


// ---- Voorstel 28 D: niet-verwerkte items (nooit stil verwijderen) + leespakket ----
const NV = "bpt_offline_niet_verwerkt";
const PAKKET = "bpt_offline_pakket";

export const nietVerwerktLijst = () => { try { return JSON.parse(localStorage.getItem(NV) || "[]"); } catch { return []; } };
const nietVerwerktBewaar = async (item) => { const l = nietVerwerktLijst(); l.unshift({ ...item, id: undefined, nv_id: `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, geweigerd_op: new Date().toISOString() }); localStorage.setItem(NV, JSON.stringify(l.slice(0, 50))); window.dispatchEvent(new Event("bpt-offline-queue")); };
export const nietVerwerktVerwijder = (nv_id) => { localStorage.setItem(NV, JSON.stringify(nietVerwerktLijst().filter((x) => x.nv_id !== nv_id))); window.dispatchEvent(new Event("bpt-offline-queue")); };
export const nietVerwerktOpnieuw = async (nv_id, payload) => { const it = nietVerwerktLijst().find((x) => x.nv_id === nv_id); if (!it) return; nietVerwerktVerwijder(nv_id); await addToQueue({ method: it.method, path: it.path, payload: payload || it.payload, label: it.label }); return flushQueue(); };

export const pakketLezen = () => { try { return JSON.parse(localStorage.getItem(PAKKET) || "null"); } catch { return null; } };
export const pakketVerversen = async () => {
  if (!navigator.onLine || !window.__bptFlags?.mobiel_offline_v1) return pakketLezen();
  try {
    const cfg = (await api.get("/offline/config")).data;
    if (!cfg.voor_mij) return null;
    const { data } = await api.get("/offline/pakket");
    localStorage.setItem(PAKKET, JSON.stringify(data));
    window.dispatchEvent(new Event("bpt-offline-pakket"));
    return data;
  } catch { return pakketLezen(); }
};
